import React from 'react';
import { CheckCircle2, Users, Globe, TrendingUp } from 'lucide-react';

const OurImpact = () => {
  const stats = [
    { icon: CheckCircle2, value: '25+', label: 'Projects Delivered', color: 'text-cyan-600' },
    { icon: Users, value: '25+', label: 'Happy Clients', color: 'text-cyan-600' },
    { icon: TrendingUp, value: '34+', label: 'Team Members', color: 'text-cyan-600' },
    { icon: Globe, value: '7+', label: 'Countries Served', color: 'text-cyan-600' },
  ];

  return (
    <section className="py-20 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Title */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Impact by the Numbers
          </h2>
          <div className="w-20 h-1 bg-cyan-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Building success stories together with our dedicated team and valued clients across the globe
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Team Photo */}
          <div className="order-2 lg:order-1">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="/team-celebration.png"
                alt="Adidar Tech Team - Empowering Digital Evolution"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Statistics */}
          <div className="order-1 lg:order-2">
            <div className="space-y-8">
              {stats.map((stat) => {
                const Icon = stat.icon;
                return (
                  <div
                    key={stat.label}
                    className="flex items-center gap-6 bg-gradient-to-r from-cyan-50 to-blue-50 p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-x-2"
                  >
                    <div className="flex-shrink-0">
                      <div className="w-16 h-16 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-full flex items-center justify-center">
                        <Icon className="w-8 h-8 text-white" />
                      </div>
                    </div>
                    <div>
                      <div className="text-4xl font-bold text-gray-900 mb-1">
                        {stat.value}
                      </div>
                      <div className="text-gray-600 text-lg font-medium">
                        {stat.label}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Bottom Message */}
        <div className="mt-16 text-center bg-gradient-to-r from-cyan-600 to-blue-600 p-8 rounded-2xl shadow-xl">
          <p className="text-white text-xl md:text-2xl font-semibold mb-2">
            Celebrating Excellence Together
          </p>
          <p className="text-cyan-50 text-lg">
            Every number represents a milestone achieved through teamwork, innovation, and dedication to our clients&apos; success
          </p>
        </div>
      </div>
    </section>
  );
};

export default OurImpact;
